// for reference:
// https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Cache-Control

export const CacheDurations = {
  VERY_SHORT: 30, // 30 seconds
  SHORT: 5 * 60, // 5 minutes
  MODEST: 60 * 60, // 1 hour
  LONG: 24 * 60 * 60, // 1 day
};

function writeResponseHeader(nodeResponse, cacheControlHeaderValue) {
  // NOTE: `Cache-Control` is overwritten by next in development mode to ensure freshness, so use a different header to at least show what would be sent in production
  if (process.env.NODE_ENV === "development") {
    nodeResponse.setHeader("X-Rtr-Cache-Control", cacheControlHeaderValue);
  } else {
    nodeResponse.setHeader("Cache-Control", cacheControlHeaderValue);
  }
}
function optionsToHeaderValue(options) {
  return Object.entries(options)
    .filter(([, v]) => v)
    .map(e => e.join("="))
    .join(", ");
}

// use this for highly cacheable content
export function withCdnCaching(nodeResponse, nodeRequest, cacheControlOptions) {
  const options = {
    "s-maxage": CacheDurations.MODEST,
    "stale-while-revalidate": 60,
    ...cacheControlOptions,
  };

  writeResponseHeader(nodeResponse, `public, ${optionsToHeaderValue(options)}`);
}

// use this for any response with personal information that changes infrequently
export function withBrowserOnlyCaching(nodeResponse, cacheControlOptions) {
  const options = {
    "max-age": CacheDurations.MODEST,
    ...cacheControlOptions,
  };

  writeResponseHeader(nodeResponse, `private, ${optionsToHeaderValue(options)}`);
}

export function withNoCaching(nodeResponse) {
  writeResponseHeader(nodeResponse, "no-store, must-revalidate");
}
